import p1_img from './product_1.jpg'
import p2_img from './product_2.jpg'
import p3_img from './product_3.jpg'
import p4_img from './product_4.jpg'

let data_product = [
  {
    id:1,
    name:"Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "medical", // Must match your category keys
    subCategory: "surgical-instruments",
    image:p1_img,
    new_price:50.00,
    old_price:80.50,
  },
  {id:2,
    name:"Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    image:p2_img,
    new_price:85.00,
    old_price:120.50,
    category: "medical", // Must match your category keys
    subCategory: "surgical-instruments",
  },
  {id:3,
    name:"Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    image:p3_img,
    new_price:60.00,
    old_price:100.50,
    category: "lab", // Must match your category keys
    subCategory: "glassware",
  },
  {id:4,
    name:"Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    image:p4_img,
    new_price:100.00,
    old_price:150.00,
    category: "chemical", // Must match your category keys
    subCategory: "acids",
  },
];

export default data_product;
